/* PB Home tracking (Oct 15 2026) — which homepage sections people actually
   see, and what they click in each one. Homepage only: loaded by
   snippets/pb-home-assets.liquid when template.name == 'index'.

   GA4 (G-3QSLWP8F7L, through the gtag the Google & YouTube app already puts
   on the page):
     home_section_view     section seen: half of it (or half the screen, for
                           tall sections) on screen for 1s. Once per page view.
     home_click            a click, with click_type:
                             product, quick_view, quick_add, cta, nav, menu,
                             search, faq, read_more, newsletter, link, button
     home_carousel_scroll  first sideways scroll/drag of a shelf or the
                           magazine strip. Once per section per page view.
   Params on all three: section_id (e.g. hoodies_shelf), section_position
   (1 = first section under the header, 0 = header, last+1 = footer),
   section_heading. home_click adds click_type, link_text, link_url,
   item_position (product cards: 1 = first card in that section).

   Microsoft Clarity (owib13u009): custom events home_view_<section_id> and
   home_click_<section_id>, so heatmaps and recordings can be filtered by
   "reached the Zippo section" or "clicked in the tees shelf".

   Only sends on the LIVE theme. On staging/dev previews it just records to
   window.pbHomeTrack. URL flags (remembered for the browser tab session):
     ?pbtrack=debug  also log every event to the console (live sends too,
                     marked debug_mode so it shows in GA4 DebugView)
     ?pbtrack=send   on a preview: really send (debug_mode)
     ?pbtrack=off    turn tracking off for this tab session
     ?pbtrack=on     clear the flag

   section_id comes from the section's key in templates/index.json, minus the
   pbh_ prefix. A section added in the editor gets a random key
   (pb_home_shelf_dzbkKP); renaming or re-adding a section starts its history
   over under the new key.

   Clicks are read in the bubble phase on purpose: the shelves and the
   magazine strip swallow the click that ends a drag (stopPropagation in
   capture), and those must not count as clicks.

   REVERT: delete this file and the {% if template.name == 'index' %} block
   in snippets/pb-home-assets.liquid. */
(function () {
  'use strict';
  if (window.__pbhTrack) return;
  window.__pbhTrack = true;

  var GA4_ID = 'G-3QSLWP8F7L';
  var VIEW_SHARE = 0.5;
  var VIEW_MS = 1000;

  var S = window.Shopify || {};
  if (S.designMode) return;

  var flag = (location.search.match(/[?&]pbtrack=(\w+)/) || [])[1];
  try {
    if (flag === 'on') { sessionStorage.removeItem('pbtrack'); flag = null; }
    else if (flag) sessionStorage.setItem('pbtrack', flag);
    else flag = sessionStorage.getItem('pbtrack');
  } catch (e) {}
  if (flag === 'off') return;

  var live = !!(S.theme && S.theme.role === 'main');
  var debug = flag === 'debug' || flag === 'send';
  var send = live || flag === 'send';
  var log = window.pbHomeTrack = [];

  /* Queue stubs, same shape as the vendors' own snippets, so events raised
     before Clarity (loaded on idle) or gtag arrive are not lost. */
  window.dataLayer = window.dataLayer || [];
  function gtag() { (window.gtag || function () { window.dataLayer.push(arguments); }).apply(window, arguments); }
  window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };

  function emit(name, params, clarityEvent) {
    log.push({ event: name, params: params, t: Math.round(performance.now()) });
    if (debug && window.console) console.log('[pb-track]', name, params);
    if (!send) return;
    try {
      var p = { send_to: GA4_ID };
      for (var k in params) if (params[k] !== '' && params[k] != null) p[k] = params[k];
      if (debug) p.debug_mode = true;
      gtag('event', name, p);
    } catch (e) {}
    try { if (clarityEvent) window.clarity('event', clarityEvent); } catch (e) {}
  }

  function clean(s, n) { return (s || '').replace(/\s+/g, ' ').trim().slice(0, n || 100); }

  /* ---- sections ---------------------------------------------------------- */
  var mains = [].slice.call(document.querySelectorAll('.shopify-section[id^="shopify-section-template--"]'));
  if (!mains.length) return;
  var first = mains[0];

  function keyOf(el) {
    return el.id.replace(/^shopify-section-/, '').split('__').pop().replace(/^pbh_/, '');
  }
  function headingOf(el) {
    var h = el.querySelector('h1, h2, h3, .pbh-hd, .pbs-h1');
    return h ? clean(h.innerText || h.textContent, 80) : '';
  }
  function describe(el, pos) {
    el.__pbt = { id: keyOf(el), pos: pos, heading: headingOf(el) };
    return el.__pbt;
  }
  mains.forEach(function (el, i) { describe(el, i + 1); });
  /* Header / footer section groups: 0 above the template, last+1 below. */
  [].forEach.call(document.querySelectorAll('.shopify-section[id^="shopify-section-sections--"]'), function (el) {
    var before = el.compareDocumentPosition(first) & Node.DOCUMENT_POSITION_FOLLOWING;
    describe(el, before ? 0 : mains.length + 1);
  });

  function base(info) {
    return { section_id: info.id, section_position: info.pos, section_heading: info.heading };
  }

  /* ---- section views ----------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    var steps = []; for (var s = 0; s <= 20; s++) steps.push(s / 20);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var el = e.target, info = el.__pbt;
        if (!info || info.seen) return;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var need = Math.min(e.boundingClientRect.height, vh) * VIEW_SHARE;
        var ok = e.isIntersecting && need > 0 && e.intersectionRect.height >= need;
        if (ok && !info.timer) {
          info.timer = setTimeout(function () {
            info.timer = 0; info.seen = true; io.unobserve(el);
            emit('home_section_view', base(info), 'home_view_' + info.id);
          }, VIEW_MS);
        } else if (!ok && info.timer) {
          clearTimeout(info.timer); info.timer = 0;
        }
      });
    }, { threshold: steps });
    mains.forEach(function (el) { io.observe(el); });
    var foot = document.querySelector('.shopify-section[id$="__pbh_footer"]');
    if (foot && foot.__pbt) io.observe(foot);
  }

  /* ---- clicks ------------------------------------------------------------ */
  function pathOf(a) {
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^javascript:/i.test(href)) return '';
    try {
      var u = new URL(href, location.href);
      return clean(u.origin === location.origin ? u.pathname + u.search : u.href, 100);
    } catch (e) { return clean(href, 100); }
  }
  /* 1-based slot of a product among the distinct products in a section, in
     page order (a card has a photo link, a title link and two quick-view
     buttons; they all share one slot). */
  function productSlot(sec, path) {
    var seen = [], links = sec.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var p = pathOf(links[i]).split('?')[0];
      if (seen.indexOf(p) < 0) seen.push(p);
      if (p === path.split('?')[0]) return seen.length;
    }
    return '';
  }
  function slotAmong(sec, el, selector) {
    var list = sec.querySelectorAll(selector);
    for (var i = 0; i < list.length; i++) if (list[i] === el) return i + 1;
    return '';
  }
  function cardOf(el) { return el.closest('.pbh-card'); }
  function cardName(card) {
    if (!card) return '';
    var n = card.querySelector('.pbh-name') || card.querySelector('[aria-label]');
    return n ? clean(n.textContent || n.getAttribute('aria-label')) : '';
  }
  function cardPath(card) {
    var a = card && card.querySelector('a[href*="/products/"]');
    return a ? pathOf(a) : '';
  }

  function sectionFor(el) {
    if (el.closest('mobile-navigation, #mobile-menu-drawer')) {
      return { id: 'menu_drawer', pos: 0, heading: '' };
    }
    var ov = el.closest('quick-buy-drawer, quick-buy-popover');
    if (ov && ov.id) {
      /* shelf quick-buy overlays are moved to <body> by pb-home.js; credit
         the section whose button opened it */
      var opener = document.querySelector('[aria-controls="' + ov.id + '"]');
      var osec = opener && opener.closest('.shopify-section');
      if (osec && osec.__pbt) return { info: osec.__pbt, sec: osec, opener: opener };
      return null;
    }
    var sec = el.closest('.shopify-section');
    return sec && sec.__pbt ? { info: sec.__pbt, sec: sec } : null;
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest && ev.target.closest('a[href], button, summary, [role="button"]');
    if (!t) return;
    if (t.matches('button[type="submit"], input[type="submit"]') || (t.tagName === 'BUTTON' && !t.getAttribute('type') && t.form)) return; // counted on submit
    var where = sectionFor(t);
    if (!where) return;
    var info = where.info || where, sec = where.sec, inOverlay = !!where.opener;

    var type, text = '', url = t.tagName === 'A' ? pathOf(t) : '', slot = '';
    var isNav = info.pos === 0;

    if (t.tagName === 'SUMMARY') {
      var d = t.parentElement;
      if (d && d.open) return; // only count opening
      type = 'faq'; text = clean(t.textContent);
      if (sec) slot = slotAmong(sec, t, 'summary');
    } else if (t.matches('.pbh-plus')) {
      var c = cardOf(t);
      type = 'quick_view'; text = cardName(c); url = cardPath(c);
      if (sec && url) slot = productSlot(sec, url);
    } else if (inOverlay) {
      if (t.tagName !== 'A' || !url) return; // option pickers, close buttons
      type = 'quick_view_link'; text = clean(t.textContent);
    } else if (/\/products\//.test(url) && !isNav) {
      type = 'product';
      var card = cardOf(t);
      text = card ? cardName(card) : clean(t.getAttribute('aria-label') || t.textContent);
      if (sec) slot = productSlot(sec, url);
    } else if (t.matches('.pbh-btn, .pbh-zbanner, .pbh-sa')) {
      type = 'cta'; text = clean(t.textContent || t.getAttribute('aria-label'));
      if (sec) slot = slotAmong(sec, t, '.pbh-btn, .pbh-zbanner, .pbh-sa');
    } else if (t.matches('.pbh-seo-more')) {
      type = 'read_more'; text = clean(t.textContent);
    } else if (t.matches('.pbh-burger')) {
      type = 'menu'; text = 'Menu';
    } else if (isNav && t.tagName === 'A') {
      type = 'nav'; text = clean(t.textContent || t.getAttribute('aria-label'));
    } else {
      type = t.tagName === 'A' ? 'link' : 'button';
      text = clean(t.getAttribute('aria-label') || t.textContent);
    }

    var p = base(info);
    p.click_type = type; p.link_text = text; p.link_url = url; p.item_position = slot;
    emit('home_click', p, 'home_click_' + info.id);
  });

  /* Form submits: search, quick-buy add to cart, footer signup. Their submit
     buttons are skipped in the click handler so nothing counts twice. */
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || f.tagName !== 'FORM') return;
    var where = sectionFor(f);
    if (!where) return;
    var info = where.info || where, action = f.getAttribute('action') || '';
    var type = /\/cart\/add/.test(action) ? 'quick_add'
      : /\/search/.test(action) ? 'search'
      : /\/contact/.test(action) ? 'newsletter' : 'form_submit';
    if (type === 'quick_add' && !where.opener) return; // not a homepage overlay
    var p = base(info);
    p.click_type = type;
    p.link_url = action;
    if (type === 'search') {
      var q = f.querySelector('input[name="q"]');
      p.link_text = clean(q && q.value, 100);
    } else if (type === 'quick_add' && where.opener) {
      var c = cardOf(where.opener);
      p.link_text = cardName(c);
      p.link_url = cardPath(c) || action;
      p.item_position = where.sec ? productSlot(where.sec, p.link_url) : '';
    }
    emit('home_click', p, 'home_click_' + info.id);
  }, true);

  /* ---- carousels: first sideways scroll / drag per section --------------- */
  function carouselTouched(el) {
    var sec = el.closest('.shopify-section'), info = sec && sec.__pbt;
    if (!info || info.scrolled) return;
    info.scrolled = true;
    emit('home_carousel_scroll', base(info), null);
  }
  document.addEventListener('scroll', function (ev) {
    var t = ev.target;
    if (t && t.classList && t.classList.contains('pbh-shelf') && t.scrollLeft > 40) carouselTouched(t);
  }, { capture: true, passive: true });
  [].forEach.call(document.querySelectorAll('.pbh-mag-vp'), function (vp) {
    var x0 = null;
    vp.addEventListener('pointerdown', function (e) { x0 = e.clientX; }, { passive: true });
    vp.addEventListener('pointermove', function (e) {
      if (x0 !== null && Math.abs(e.clientX - x0) > 30) { x0 = null; carouselTouched(vp); }
    }, { passive: true });
    vp.addEventListener('pointerup', function () { x0 = null; }, { passive: true });
    vp.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 4) carouselTouched(vp);
    }, { passive: true });
  });
})();
